import React from "react";

const ReadMoreBtn = () => {
	return (
		<div className="py-5 px-8 cursor-pointer text-lg font-semibold bg-black  text-white  hover:bg-PBlue transition-all duration-700 rounded-xl">
			Read More
		</div>
	);
};

export default ReadMoreBtn;
